import { type SvgProps, SvgWrapper } from '../utils';
export function TimeIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12ZM11.25 6C11.25 5.58579 11.5858 5.25 12 5.25C12.4142 5.25 12.75 5.58579 12.75 6V11.5361L16.335 13.3291C16.7053 13.5143 16.8558 13.9646 16.6709 14.335C16.4857 14.7053 16.0354 14.8558 15.665 14.6709L11.665 12.6709C11.411 12.5439 11.25 12.2841 11.25 12V6ZM22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12Z" />
    </SvgWrapper>
  );
}
